"use client";

import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import {
    Box,
    Image,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from "@/components/controls/base-controls";
import {
    HEADER_HEIGHT_FULL,
    WEBPAGE_CORE_CONTAINER,
} from "@/core/constants/webpages";
import useResponsiveImage from "@/core/hooks/use-responsive-image";

const ServicesPlanning = () => {
    const t = useTranslations();
    const theme = useTheme();

    const isMd = useMediaQuery(theme.breakpoints.up("md"));
    
    const callout = useResponsiveImage(
        {
            src: "https://general-images.navairra.com/chaise_poolside_960x680.png",
            width: 420,
            height: 900,
        },
        {
            src: "https://general-images.navairra.com/chaise_poolside_1015x900.png",
            width: 900,
            height: 420,
        },
        {
            src: "https://general-images.navairra.com/chaise_poolside_1015x900.png",
            width: 480,
            height: 420,
        },
        {
            src: "https://general-images.navairra.com/chaise_poolside_1015x900.png",
            width: 768,
            height: 680,
        },
        {
            src: "https://general-images.navairra.com/chaise_poolside_1015x900.png",
            width: 1015,
            height: 900,
        },
    );

    return (
        <Box
            sx={{
                backgroundColor: "var(--mui-palette-page-bg)",
                margin: "0 auto",
                width: WEBPAGE_CORE_CONTAINER,
                maxWidth: "100%",
                padding: { xs: "1em 0 0", md: "0 0" },
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "65fr 35fr" },
                gap: { xs: "1em", md: "1em" },
                height: "100%",
                maxHeight: {
                    xs: "100%",
                    md: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                },
                overflowY: "hidden",
            }}
        >
            <Stack
                component={motion.div} 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                
                sx={{
                    direction:"column",
                    justifyContent:"center",
                    padding: { xs: "1em", md: "1em 7em" }
                }}             
            >
                <Stack>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "var(--mui-palette-darkest)",
                            fontWeight: "bold"
                        }}
                    >
                        {t("services.planning.heading1")}
                    </Typography>

                    <Typography variant="body1" component="div"
                        sx={{
                            color: "var(--mui-palette-darkest)",
                            mt: "1em"
                        }}
                    >
                        {t.rich("services.planning.details1", {
                            p: (chunks) => <p style={{ margin: "1em 0 0" }}>{chunks}</p>
                        })}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: "var(--mui-palette-darkest)",
                            fontWeight: "bold",
                            mt: "1.5em"
                        }}
                    >
                        {t("services.planning.heading2")}
                    </Typography>

                    <Typography variant="body1" component="div"
                        sx={{
                            color: "var(--mui-palette-darkest)",
                            mt: "1em"
                        }}
                    >
                        {t.rich("services.planning.details2", {
                            p: (chunks) => <p style={{ margin: "1em 0 0" }}>{chunks}</p>
                        })}
                    </Typography>
                </Stack>
            </Stack>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                    maxHeight: {
                        xs: "50svh",
                        md: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                    },
                    "@media (orientation: landscape)": {
                        maxHeight: {
                            xs: "120svh",
                            md: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                        },
                    },
                    overflow: "hidden",
                }}
            >
                <Image
                    src={callout.src}
                    alt={t("services.planning.image1")}
                    width={callout.width}
                    height={callout.height}
                    loading={"eager"}
                    style={{
                        width: "100%",
                        height: `calc(100vh - ${HEADER_HEIGHT_FULL})`,
                        objectFit: "cover",
                        objectPosition: isMd ? "center right" : "65% 50%",
                    }}
                />
            </Box>
        </Box>
    );

};

export default ServicesPlanning;
